import React from 'react';
import { compose, withHandlers } from 'recompose';
import { withStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import withLoader from '../app/withLoader';
import { withRouter } from 'react-router-dom';
import AddAttributeForm from './form/addForm';
import { createAttribute } from './_api';
import { withSnackbar } from 'notistack';
import { get } from 'lodash';

const styles = theme => ({
  root: {
    width: '100%',
    margin: 20,
  },
  heading: {
    fontSize: theme.typography.pxToRem(15),
    fontWeight: theme.typography.fontWeightRegular,
  },
  paper: {
    padding: theme.spacing.unit,
    textAlign: 'left',
    color: theme.palette.text.secondary,
  },
});

const enhance = compose(
  withStyles(styles),
  withSnackbar,
  withLoader,
  withRouter,
  withHandlers({
    onSubmit: ({ history, toggleLoader, enqueueSnackbar }) => async values => {
      toggleLoader();
      const resp = await createAttribute(values);
      if (get(resp, 'success', false)) {
        enqueueSnackbar('Atributa byla úspěšně uložena.', { variant: 'success' });
        history.push('/attributes');
      } else {
        enqueueSnackbar('Atributu se nepodařilo uložit.', { variant: 'error' });
      }
      toggleLoader(false);
    },
  }),
);

export default enhance(({ classes, onSubmit }) => (
  <div className={classes.root}>
    <h3>Přidat atribut</h3>
    <Paper className={classes.paper}>
      <AddAttributeForm onSubmit={onSubmit} />
    </Paper>
  </div>
));



// WEBPACK FOOTER //
// ./src/modules/attributes/add.js